import withFormField, { PropsType } from "../hoc/withFormField";

export default withFormField(props => <select {...props} />) as React.FC<PropsType>